import {
  ButtonItem,
  Form,
  Item,
  Label,
  RequiredRule,
} from "devextreme-react/form";
import { LookupTypes } from "devextreme-react/lookup";
import { Popup } from "devextreme-react/popup";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  disableAccountLocks,
  downloadUsersToChangePassword,
} from "../../api/settings";
import "./DisableAccountLocks.scss";

export const DisableAccountLocks = () => {
  const { t } = useTranslation();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isSuccessModalVisible, setIsSuccessModalVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState<string>("");
  const [users, setUsers] = useState<{ id: number; email: string }[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (isModalVisible) {
      const fetchUsers = async () => {
        try {
          const response = await downloadUsersToChangePassword();

          if (response.data && Array.isArray(response.data)) {
            setUsers(response.data);
          } else {
            const usersList = response.data.data || [];
            setUsers(usersList);
          }
        } catch (err) {
          console.error("Error when try download users data", err);
        }
      };
      fetchUsers();
    }
  }, [isModalVisible]);

  useEffect(() => {}, [users]);

  const handlePopup = () => {
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
  };

  const handleSuccessModalClose = () => {
    setIsSuccessModalVisible(false);
  };

  const handleChangePassword = async () => {
    if (!email) {
      alert(t("Please select a user"));
      return;
    }

    setIsLoading(true);
    try {
      const response = await disableAccountLocks(email);
      if (response.isOk) {
        setIsModalVisible(false);
        setIsSuccessModalVisible(true);
      } else {
        setError(
          response.error || t("An error occurred while changing the password.")
        );
        setIsModalVisible(false);
        setIsSuccessModalVisible(true);
      }
    } catch (error) {
      setError(t("An error occurred while changing the password."));
      setIsModalVisible(false);
      setIsSuccessModalVisible(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="disable-account-locks">
      <h1>{t("Disable account locks")}</h1>
      <p>
        {t(
          "On this page, you can disable account locks for your organization's user account"
        )}
      </p>
      <button className="disable-account-locks-button" onClick={handlePopup}>
        {t("Disable locks")}
      </button>

      <Popup
        visible={isModalVisible}
        onHiding={handleCloseModal}
        maxWidth={300}
        height="auto"
        maxHeight="80vh"
        showTitle={true}
        title={t("Disable account locks")}
        showCloseButton
        dragEnabled
      >
        <Form>
          <Item
            dataField="userId"
            editorType="dxLookup"
            editorOptions={
              {
                items: users,
                displayExpr: "email",
                valueExpr: "email",
                value: email,
                width: 250,
                onValueChanged: (e: any) => setEmail(e.value),
                placeholder: t("Select a user"),
                dropDownOptions: {
                  height: 300,
                  showScrollbar: "onHover",
                  hideOnOutsideClick: true,
                  showTitle: false,
                },
              } as LookupTypes.Properties
            }
          >
            <RequiredRule message={t("User selection is required")} />
            <Label text={t("User")} />
          </Item>
          <ButtonItem
            buttonOptions={{
              text: t("Send"),
              type: "default",
              onClick: handleChangePassword,
              disabled: isLoading,
            }}
          />
        </Form>
      </Popup>

      <Popup
        visible={isSuccessModalVisible}
        onHiding={handleSuccessModalClose}
        maxWidth={400}
        height="auto"
        maxHeight="80vh"
        title={t(" Disable locks status")}
        showCloseButton
        dragEnabled
      >
        <div className="success-content">
          {error ? (
            <p className="error-message">{error}</p>
          ) : (
            <p>{t("Account locks disabled")}</p>
          )}
        </div>
      </Popup>
    </div>
  );
};
